import { HorizBox, Pad } from 'component/basics';
import { colorTextSecondary } from 'component/color';
import { UtilityText } from 'component/text';
import React from 'react';
import { View } from 'react-native';
import { getPrettyTimestamp } from 'system/videotime';
import { usePersonaKey } from 'util/datastore';
import { t } from 'util/stdtypes';

import { VideoVotingOption } from './videoVotingQuestionElements';

export function QuestionResultIndividual({ question, allVotes = [] }) {
    const personaKey = usePersonaKey();
    const personalVote = allVotes.find((vote) => vote.from === personaKey && vote.questionKey === question.key);

    return (
        <View>
            <HorizBox>
                <UtilityText color={colorTextSecondary} label={t('Time:')} />
                <Pad size={5} />
                <UtilityText color={colorTextSecondary} text={getPrettyTimestamp(question.timestamp)} />
            </HorizBox>
            <Pad size={10} />
            {question.options.map((option, idx) => {
                const votesOfOption = allVotes.filter((v) => v.optionKey === option.key);
                return (
                    <View key={idx}>
                        <VideoVotingOption
                            allVoteCount={allVotes.length}
                            optionText={option.text}
                            selected={personalVote?.optionKey === option.key}
                            showResults
                            voteCount={votesOfOption.length}
                            voterKeys={votesOfOption.map((v) => (v.anonymous ? null : v.from))}
                        />
                    </View>
                );
            })}
        </View>
    );
}
